import React, { useState, useEffect } from "react";
import { getData, postData, putData } from "../../services/api.service";
import { toastSuccess, toastError } from "../common/Toast";
import {
  FaUsers,
  FaPlus,
  FaEdit,
  FaTrash,
  FaSave,
  FaExclamationTriangle,
  FaCheck,
  FaTimes,
  FaUser,
  FaEnvelope,
  FaKey,
  // FaPercentage, // ELIMINADO: módulo comisiones removido
  FaUserTie,
  FaEye,
  FaEyeSlash,
  FaFilter
} from "react-icons/fa";

function UsersManager() {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  // const [commissions, setCommissions] = useState([]); // ELIMINADO: módulo comisiones removido
  const [paymentMethods, setPaymentMethods] = useState([]); // Nuevo estado
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [deletingUser, setDeletingUser] = useState(null);
  const [changingPasswordUser, setChangingPasswordUser] = useState(null);
  const [filterRole, setFilterRole] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showInactive, setShowInactive] = useState(false);
  const [formData, setFormData] = useState({
    user_id: '',
    username: '',
    user_rol: '',
    active: true,
    email: '',
    password: '',
    first_login: 1,
    // seller_comission: '', // ELIMINADO: módulo comisiones removido
    payment_method_ids: []
  });
  const [passwordData, setPasswordData] = useState({
    password: '',
    confirmPassword: ''
  });

  useEffect(() => {
    loadUsers();
    loadRoles();
    // loadCommissions(); // ELIMINADO: módulo comisiones removido
    loadPaymentMethods(); // Cargar métodos de pago
  }, []);

  useEffect(() => {
    loadUsers();
  }, [filterRole]);

  const loadUsers = async () => {
    try {
      setLoading(true);
      
      let endpoint = '/api/get_users';
      
      const response = await getData(endpoint);
      
      let usersData = [];
      
      if (response && response.data) {
        if (Array.isArray(response.data)) {
          usersData = response.data;
        } else if (response.data.users && Array.isArray(response.data.users)) {
          usersData = response.data.users;
        } else {
          Object.keys(response.data).forEach(key => {
            if (Array.isArray(response.data[key]) && usersData.length === 0) {
              usersData = response.data[key];
            }
          });
        }
      }
      
      // Filtrar por rol si está seleccionado
      if (filterRole) {
        usersData = usersData.filter(user => user.user_rol == filterRole);
      }
      
      if (!Array.isArray(usersData)) {
        usersData = [];
      }
      
      setUsers(usersData);
    } catch (error) {
      console.error('Error cargando usuarios:', error);
      toastError('Error al cargar los usuarios');
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const loadRoles = async () => {
    try {
      const response = await getData('/api/admin/get_roles');
      let rolesData = [];
      
      if (response && response.data) {
        if (Array.isArray(response.data)) {
          rolesData = response.data;
        } else if (response.data.roles && Array.isArray(response.data.roles)) {
          rolesData = response.data.roles;
        }
      }
      
      setRoles(rolesData.filter(role => role.active));
    } catch (error) {
      console.error('Error cargando roles:', error);
    }
  };

  /* ELIMINADO: módulo comisiones removido
  const loadCommissions = async () => {
    try {
      const response = await getData('/api/admin/get_commissions');
      let commissionsData = [];
      if (response && response.data) {
        if (Array.isArray(response.data)) {
          commissionsData = response.data;
        } else if (response.data.commissions && Array.isArray(response.data.commissions)) {
          commissionsData = response.data.commissions;
        }
      }
      setCommissions(commissionsData.filter(commission => commission.active));
    } catch (error) {
      console.error('Error cargando comisiones:', error);
    }
  };
  */

  const loadPaymentMethods = async () => {
    try {
      const response = await getData('/api/admin/get_payment_methods');
      let methodsData = [];
      
      if (response && response.data) {
        if (Array.isArray(response.data)) {
          methodsData = response.data;
        } else if (response.data.paymentMethods && Array.isArray(response.data.paymentMethods)) {
          methodsData = response.data.paymentMethods;
        }
      }
      
      setPaymentMethods(methodsData.filter(method => method.active));
    } catch (error) {
      console.error('Error cargando métodos de pago:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      
      // Validaciones
      if (formData.user_id.length < 7 || formData.user_id.length > 8) {
        toastError('El DNI debe tener entre 7 y 8 dígitos');
        return;
      }
      
      if (!editingUser && formData.password.length < 6) {
        toastError('La contraseña debe tener al menos 6 caracteres');
        return;
      }
      
      // if (formData.user_rol == 2 && !formData.seller_comission) { // ELIMINADO: módulo comisiones removido
      //   toastError('Debe seleccionar una comisión para los vendedores');
      //   return;
      // }

      if (formData.user_rol == 2 && formData.payment_method_ids.length === 0){
        toastError('Debe seleccionar al menos un método de pago para los vendedores');
        return;
      }
      
      const dataToSend = {
        data: {
          user_id: formData.user_id.trim(),
          username: formData.username.trim(),
          user_rol: parseInt(formData.user_rol),
          active: formData.active,
          email: formData.email.trim(),
          first_login: formData.first_login,
          // seller_comission: formData.user_rol == 2 ? parseInt(formData.seller_comission) : null, // ELIMINADO: módulo comisiones removido
          payment_method_ids: formData.user_rol == 2 ? formData.payment_method_ids.map(Number) : [],
          [editingUser ? 'updated_by' : 'inserted_by']: 1 // TODO: Obtener del contexto de usuario actual
        }
      };
      
      // Solo incluir password en creación
      if (!editingUser) {
        dataToSend.data.password = formData.password;
      }
      
      if (editingUser) {
        await putData('/api/update_user', dataToSend);
        toastSuccess(`Usuario "${formData.username}" actualizado exitosamente`);
      } else {
        await postData('/api/create_user', dataToSend);
        toastSuccess(`Usuario "${formData.username}" creado exitosamente`);
      }
      
      setShowModal(false);
      resetForm();
      await loadUsers();
    } catch (error) {
      console.error('Error guardando usuario:', error);
      toastError(editingUser ? 'Error al actualizar el usuario' : 'Error al crear el usuario');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      
      if (passwordData.password !== passwordData.confirmPassword) {
        toastError('Las contraseñas no coinciden');
        return;
      }
      
      if (passwordData.password.length < 6) {
        toastError('La contraseña debe tener al menos 6 caracteres');
        return;
      }
      
      const dataToSend = {
        data: {
          user_id: changingPasswordUser.user_id,
          password: passwordData.password,
          updated_by: 1 // TODO: Obtener del contexto de usuario actual
        }
      };
      
      await putData('/api/update_user_password', dataToSend);
      toastSuccess(`Contraseña actualizada para "${changingPasswordUser.username}"`);
      
      setShowPasswordModal(false);
      setChangingPasswordUser(null);
      setPasswordData({ password: '', confirmPassword: '' });
      await loadUsers();
    } catch (error) {
      console.error('Error actualizando contraseña:', error);
      toastError('Error al actualizar la contraseña');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setEditingUser(null);
    setFormData({
      user_id: '',
      username: '',
      user_rol: '',
      active: true,
      email: '',
      password: '',
      first_login: 1,
      // seller_comission: '', // ELIMINADO: módulo comisiones removido
      payment_method_ids: []
    });
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      user_id: user.user_id || '',
      username: user.username || '',
      user_rol: user.user_rol || '',
      active: user.active !== undefined ? Boolean(user.active) : true,
      email: user.email || '',
      password: '',
      first_login: user.first_login || 1,
      // seller_comission: user.seller_comission || '', // ELIMINADO: módulo comisiones removido
      payment_method_ids: Array.isArray(user.payment_method_ids) ? user.payment_method_ids : []
    });
    setShowModal(true);
  };

  const handleNew = () => {
    setEditingUser(null);
    setFormData({
      user_id: '',
      username: '',
      user_rol: '',
      active: true,
      email: '',
      password: '',
      first_login: 1,
      // seller_comission: '', // ELIMINADO: módulo comisiones removido
      payment_method_ids: []
    });
    setShowModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Toggle para agregar/quitar un método de pago del array
  const handlePaymentMethodToggle = (pmId) => {
    setFormData(prev => {
      const ids = prev.payment_method_ids.includes(pmId)
        ? prev.payment_method_ids.filter(id => id !== pmId)
        : [...prev.payment_method_ids, pmId];
      return { ...prev, payment_method_ids: ids };
    });
  };

  const handlePasswordInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDelete = (user) => {
    setDeletingUser(user);
    setShowDeleteModal(true);
  };

  const handleChangePassword = (user) => {
    setChangingPasswordUser(user);
    setPasswordData({ password: '', confirmPassword: '' });
    setShowPasswordModal(true);
  };

  const confirmDelete = async () => {
    if (!deletingUser) return;
    
    try {
      setLoading(true);
      
      // Usar PUT para marcar como inactivo (soft delete)
      const dataToSend = {
        data: {
          user_id: deletingUser.user_id,
          username: deletingUser.username,
          user_rol: deletingUser.user_rol,
          active: false,
          email: deletingUser.email,
          // seller_comission: deletingUser.seller_comission, // ELIMINADO: módulo comisiones removido
          payment_method_ids: Array.isArray(deletingUser.payment_method_ids) ? deletingUser.payment_method_ids : [],
          updated_by: 1
        }
      };
      
      await putData('/api/update_user', dataToSend);
      toastSuccess(`Usuario "${deletingUser.username}" desactivado exitosamente`);
      setShowDeleteModal(false);
      setDeletingUser(null);
      await loadUsers();
    } catch (error) {
      console.error('Error desactivando usuario:', error);
      toastError('Error al desactivar el usuario');
    } finally {
      setLoading(false);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setDeletingUser(null);
  };

  // Función para obtener el nombre del rol
  const getRoleName = (roleId) => {
    const role = roles.find(r => r.id === roleId);
    return role ? role.role_description : `Rol #${roleId}`;
  };

  /* ELIMINADO: módulo comisiones removido
  const getCommissionName = (commissionId) => {
    if (!commissionId) return 'No aplica';
    const commission = commissions.find(c => c.id === commissionId);
    return commission ? `${commission.commission_description} (${commission.commission_rate}%)` : `Comisión #${commissionId}`;
  };
  */

  // Función para obtener el nombre del método de pago (legacy, mantener por si acaso)
  const getPaymentMethodName = (paymentMethodId) => {
    if (!paymentMethodId) return 'No asignado';
    const method = paymentMethods.find(m => m.id === paymentMethodId);
    return method ? method.payment_description : `Método #${paymentMethodId}`;
  };

  // Función para obtener el color del badge según el rol
  const getRoleBadgeColor = (roleId) => {
    switch (roleId) {
      case 1: return 'bg-danger'; // Admin
      case 2: return 'bg-success'; // Vendedor
      case 3: return 'bg-primary'; // Supervisor
      default: return 'bg-secondary';
    }
  };

  // Filtrar usuarios según el toggle
  const filteredUsers = showInactive 
    ? users 
    : users.filter(user => user.active);

  return (
    <div className="users-manager">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">
            <FaUsers className="me-2 text-primary" />
            Gestión de Usuarios
          </h5>
          <div className="d-flex gap-2 align-items-center">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="showInactiveToggle"
                checked={showInactive}
                onChange={(e) => setShowInactive(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="showInactiveToggle">
                Mostrar inactivos
              </label>
            </div>
            <button
              className="btn btn-primary"
              onClick={handleNew}
              disabled={loading}
            >
              <FaPlus className="me-2" />
              Nuevo Usuario
            </button>
          </div>
        </div>

        <div className="card-body">
          {/* Filtro por rol */}
          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label">
                <FaFilter className="me-2" />
                Filtrar por Rol
              </label>
              <select
                className="form-select"
                value={filterRole}
                onChange={(e) => setFilterRole(e.target.value)}
                disabled={loading}
              >
                <option value="">Todos los roles</option>
                {roles.map(role => (
                  <option key={role.id} value={role.id}>
                    {role.role_description}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {!showInactive && users.length > filteredUsers.length && (
            <div className="alert alert-info d-flex justify-content-between align-items-center mb-3">
              <div>
                <i className="fas fa-info-circle me-2"></i>
                Hay <strong>{users.length - filteredUsers.length}</strong> elemento(s) inactivo(s) oculto(s).
              </div>
              <button 
                className="btn btn-sm btn-outline-primary"
                onClick={() => setShowInactive(true)}
              >
                Mostrar todos
              </button>
            </div>
          )}

          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              <div className="mt-2 text-muted">Cargando usuarios...</div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>DNI</th>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>Rol</th>
                    {/* <th>Comisión</th> ELIMINADO: módulo comisiones removido */}
                    <th>Método de Pago</th>
                    <th>Estado</th>
                    <th>Primer Login</th>
                    <th>Fecha Creación</th>
                    <th className="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {!Array.isArray(filteredUsers) || filteredUsers.length === 0 ? (
                    <tr>
                      <td colSpan="9" className="text-center text-muted py-4">
                        {!Array.isArray(users) ? 
                          'Error cargando usuarios' : 
                          filterRole ? (
                            showInactive ? 'No hay usuarios con este rol' : 'No hay usuarios activos con este rol'
                          ) : (
                            showInactive ? 'No hay usuarios registrados' : 'No hay usuarios activos. Activa el toggle "Mostrar inactivos" para ver usuarios desactivados.'
                          )
                        }
                      </td>
                    </tr>
                  ) : (
                    filteredUsers.map(user => (
                      <tr key={user.user_id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <FaUser className="me-2 text-info" />
                            <strong>{user.user_id}</strong>
                          </div>
                        </td>
                        <td>
                          <span className="fw-bold">{user.username}</span>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <FaEnvelope className="me-2 text-muted" />
                            <small>{user.email}</small>
                          </div>
                        </td>
                        <td>
                          <span className={`badge ${getRoleBadgeColor(user.user_rol)}`}>
                            <FaUserTie className="me-1" />
                            {getRoleName(user.user_rol)}
                          </span>
                        </td>
                        {/* ELIMINADO: módulo comisiones removido
                        <td>
                          {user.user_rol == 2 ? (
                            <span className="badge bg-warning text-dark">
                              {getCommissionName(user.seller_comission)}
                            </span>
                          ) : (
                            <small className="text-muted">No aplica</small>
                          )}
                        </td>
                        */}
                        <td>
                          {user.user_rol == 2 ? (
                            user.payment_descriptions && user.payment_descriptions.length > 0 ? (
                              <div className="d-flex flex-wrap gap-1">
                                {user.payment_descriptions.map((desc, idx) => (
                                  <span key={idx} className="badge bg-info">{desc}</span>
                                ))}
                              </div>
                            ) : (
                              <span className="badge bg-secondary">No asignado</span>
                            )
                          ) : (
                            <small className="text-muted">No aplica</small>
                          )}
                        </td>
                        <td>
                          <span className={`badge ${user.active ? 'bg-success' : 'bg-danger'}`}>
                            {user.active ? (
                              <>
                                <FaCheck className="me-1" />
                                Activo
                              </>
                            ) : (
                              <>
                                <FaTimes className="me-1" />
                                Inactivo
                              </>
                            )}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${user.first_login ? 'bg-warning' : 'bg-info'}`}>
                            {user.first_login ? 'Pendiente' : 'Completado'}
                          </span>
                        </td>
                        <td>
                          <small className="text-muted">
                            {user.inserted_date ? new Date(user.inserted_date).toLocaleDateString('es-AR') : 'N/A'}
                          </small>
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-primary me-1"
                            onClick={() => handleEdit(user)}
                            disabled={loading}
                            title="Editar usuario"
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-warning me-1"
                            onClick={() => handleChangePassword(user)}
                            disabled={loading}
                            title="Cambiar contraseña"
                          >
                            <FaKey />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(user)}
                            disabled={loading || !user.active}
                            title={user.active ? "Desactivar usuario" : "Usuario ya inactivo"}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal para crear/editar usuario */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingUser ? 'Editar Usuario' : 'Nuevo Usuario'}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                  disabled={loading}
                ></button>
              </div>
              
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">DNI *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="user_id"
                          value={formData.user_id}
                          onChange={handleInputChange}
                          required
                          disabled={loading || editingUser} // No editable en modo edición
                          placeholder="12345678"
                          pattern="[0-9]{7,8}"
                          title="DNI debe tener entre 7 y 8 dígitos"
                        />
                        <div className="form-text">
                          Documento de identidad (7-8 dígitos, solo números)
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Nombre Completo *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="username"
                          value={formData.username}
                          onChange={handleInputChange}
                          required
                          disabled={loading}
                          placeholder="Juan Pérez"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email *</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          disabled={loading}
                          placeholder="juan.perez@example.com"
                        />
                      </div>

                      {!editingUser && (
                        <div className="mb-3">
                          <label className="form-label">Contraseña *</label>
                          <div className="input-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              name="password"
                              value={formData.password}
                              onChange={handleInputChange}
                              required
                              disabled={loading}
                              placeholder="Mínimo 6 caracteres"
                              minLength="6"
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>
                          <div className="form-text">
                            Contraseña temporal (el usuario deberá cambiarla en el primer login)
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Rol *</label>
                        <select
                          className="form-select"
                          name="user_rol"
                          value={formData.user_rol}
                          onChange={handleInputChange}
                          required
                          disabled={loading}
                        >
                          <option value="">Selecciona un rol</option>
                          {roles.map(role => (
                            <option key={role.id} value={role.id}>
                              {role.role_description}
                            </option>
                          ))}
                        </select>
                      </div>

                      {formData.user_rol == 2 && (
                        <>
                          {/* ELIMINADO: módulo comisiones removido
                          <div className="mb-3">
                            <label className="form-label">Comisión de Vendedor *</label>
                            <select name="seller_comission">
                              <option value="">Selecciona una comisión</option>
                            </select>
                          </div>
                          */}

                          <div className="mb-3">
                            <label className="form-label">Métodos de Pago Asignados *</label>
                            <div
                              className={`border rounded p-2 ${loading ? 'bg-light' : 'bg-white'}`}
                              style={{ minHeight: '44px' }}
                            >
                              {paymentMethods.length === 0 ? (
                                <small className="text-muted">Cargando métodos de pago...</small>
                              ) : (
                                paymentMethods.map(method => {
                                  const isSelected = formData.payment_method_ids.includes(method.id);
                                  return (
                                    <span
                                      key={method.id}
                                      className={`badge me-1 mb-1 ${isSelected ? 'bg-primary' : 'bg-light text-dark border'}`}
                                      style={{ cursor: loading ? 'default' : 'pointer', fontSize: '0.85em', padding: '6px 10px', userSelect: 'none' }}
                                      onClick={() => !loading && handlePaymentMethodToggle(method.id)}
                                    >
                                      {isSelected && <FaCheck className="me-1" style={{ fontSize: '0.75em' }} />}
                                      {method.payment_description}
                                    </span>
                                  );
                                })
                              )}
                            </div>
                            <div className="form-text">
                              Clic para seleccionar / deseleccionar.{' '}
                              <strong>{formData.payment_method_ids.length}</strong> {formData.payment_method_ids.length === 1 ? 'método seleccionado' : 'métodos seleccionados'}.
                            </div>
                          </div>
                        </>
                      )}

                      <div className="mb-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="active"
                            checked={formData.active}
                            onChange={handleInputChange}
                            disabled={loading}
                          />
                          <label className="form-check-label">
                            <FaCheck className="me-2 text-success" />
                            Usuario activo
                          </label>
                          <div className="form-text">
                            Los usuarios inactivos no pueden acceder al sistema
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="first_login"
                            checked={formData.first_login}
                            onChange={(e) => setFormData(prev => ({ ...prev, first_login: e.target.checked ? 1 : 0 }))}
                            disabled={loading}
                          />
                          <label className="form-check-label">
                            <FaKey className="me-2 text-warning" />
                            Forzar cambio de contraseña
                          </label>
                          <div className="form-text">
                            El usuario deberá cambiar su contraseña en el primer login
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="alert alert-info">
                    <FaUsers className="me-2" />
                    <strong>Nota:</strong> {editingUser ? 'Los cambios se aplicarán inmediatamente. Para cambiar la contraseña, usa el botón específico.' : 'El usuario recibirá sus credenciales por email y deberá cambiar la contraseña en el primer acceso.'}
                  </div>
                </div>
                
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                    disabled={loading}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading || !formData.user_id || !formData.username || !formData.email || !formData.user_rol || (formData.user_rol == 2 && formData.payment_method_ids.length === 0) || (!editingUser && !formData.password)}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Guardando...
                      </>
                    ) : (
                      <>
                        <FaSave className="me-2" />
                        {editingUser ? 'Actualizar' : 'Crear'}
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal para cambiar contraseña */}
      {showPasswordModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <FaKey className="me-2 text-warning" />
                  Cambiar Contraseña
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPasswordModal(false)}
                  disabled={loading}
                ></button>
              </div>
              
              <form onSubmit={handlePasswordSubmit}>
                <div className="modal-body">
                  <p>Cambiar contraseña para: <strong>{changingPasswordUser?.username}</strong></p>
                  
                  <div className="mb-3">
                    <label className="form-label">Nueva Contraseña *</label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        name="password"
                        value={passwordData.password}
                        onChange={handlePasswordInputChange}
                        required
                        disabled={loading}
                        placeholder="Mínimo 6 caracteres"
                        minLength="6"
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Confirmar Contraseña *</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      name="confirmPassword"
                      value={passwordData.confirmPassword}
                      onChange={handlePasswordInputChange}
                      required
                      disabled={loading}
                      placeholder="Repite la contraseña"
                    />
                  </div>

                  <div className="alert alert-warning">
                    <FaExclamationTriangle className="me-2" />
                    Esta acción restablecerá el flag de primer login, por lo que el usuario deberá cambiar nuevamente su contraseña.
                  </div>
                </div>
                
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowPasswordModal(false)}
                    disabled={loading}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="btn btn-warning"
                    disabled={loading || !passwordData.password || !passwordData.confirmPassword}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Actualizando...
                      </>
                    ) : (
                      <>
                        <FaKey className="me-2" />
                        Cambiar Contraseña
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmación de eliminación */}
      {showDeleteModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <FaExclamationTriangle className="text-warning me-2" />
                  Confirmar Desactivación
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={cancelDelete}
                  disabled={loading}
                ></button>
              </div>
              <div className="modal-body">
                <p>¿Estás seguro que deseas desactivar al usuario <strong>"{deletingUser?.username}"</strong> (DNI: {deletingUser?.user_id})?</p>
                <div className="alert alert-warning">
                  <FaExclamationTriangle className="me-2" />
                  El usuario será marcado como inactivo y no podrá acceder al sistema.
                </div>
                <div className="alert alert-info">
                  <FaUsers className="me-2" />
                  Puedes reactivar el usuario editándolo y marcando "Usuario activo".
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={cancelDelete}
                  disabled={loading}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmDelete}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Desactivando...
                    </>
                  ) : (
                    <>
                      <FaTrash className="me-2" />
                      Desactivar
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UsersManager;
